import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OfflineGcGenInfoComponent } from './offline-gc-gen-info/offline-gc-gen-info.component';
import { OfflineGcTnComponent } from './offline-gc-tn/offline-gc-tn.component';
import { GcRedeemInfoComponent } from './gc-redeem-info/gc-redeem-info.component';
import { MaterializeModule } from 'angular2-materialize';
import { FormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { ZestCommonModule } from 'app/common/common.module';
import { GiftCardService } from 'app/landing-pages/gift-card/gift-card.service';

@NgModule({
  imports: [
    CommonModule,
    MaterializeModule,
    FormsModule,
    TextMaskModule,
    ZestCommonModule
  ],
  declarations: [
    OfflineGcGenInfoComponent,
    OfflineGcTnComponent,
    GcRedeemInfoComponent
  ],
  exports: [
    OfflineGcGenInfoComponent,
    OfflineGcTnComponent,
    GcRedeemInfoComponent
  ],
  providers: [
    GiftCardService,
  ]
})
export class OfflineGcModule { }
